import { FC } from 'react'
import {
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Typography,
} from '@mui/material'
import { DialogNames } from 'src/enums'
import { StatefulDialog } from 'src/components/ui'

export type SettingsItem = {
  name: string
  oldValue?: string
  newValue?: string
}

interface Props {
  onSubmit: () => void
  onCloseDialog: () => void
}

export const EditIncludedEventsModal: FC<Props> = ({
  onSubmit,
  onCloseDialog,
}) => {
  return (
    <StatefulDialog
      name={DialogNames.EditReportIncludedEvents}
      onClose={() => onCloseDialog()}
      actions={
        <DialogActions>
          <Button onClick={() => onCloseDialog()}>
            Close
          </Button>
          <Button
            onClick={onSubmit}
            color='error'
          >
            Edit
          </Button>
        </DialogActions>
      }
    >
      <DialogTitle id="alert-dialog-title">
        Edit included events
      </DialogTitle>
      <DialogContent>
        <DialogContentText component='div' sx={{ mb: 2 }}>
          <Typography variant="body1" component="span">Are you sure you want to edit included report events?</Typography>
          <Typography variant="body1" fontWeight={600}>
            Changes will be applied immediately
          </Typography>
        </DialogContentText>
      </DialogContent>
    </StatefulDialog>
  )
}
